import { createSlice } from '@reduxjs/toolkit';

import {
	commonReducers,
	CommonState,
	initialCommonState,
} from '../_common/commonReducers';

export interface TaskScheduler {
	Id: number;
	// Historical column-name typo kept by the backend so filters and patch
	// paths resolve without aliases.
	IsEnalbed: boolean;
	Repeat: string;
	Type: string;
	PathToJSONConfig: string | null;
	DifferenceInMinutes: number | null;
	LastSchedule: string | null;
	Config: string | null;
	Modified: string | null;
}

interface TaskSchedulerState extends CommonState {}

const initialState: TaskSchedulerState = {
	...initialCommonState,
};

const taskSchedulerSlice = createSlice({
	name: 'taskScheduler',
	initialState,
	reducers: {
		...commonReducers,
	},
});

export const {
	getTableStart,
	getTableSuccess,
	getTableFailure,
	getTableFinish,

	getItemStart,
	getItemSuccess,
	getItemFailure,

	createItemStart,
	createItemSuccess,
	createItemFailure,
	createItemFinish,

	updateItemStart,
	updateItemSuccess,
	updateItemFailure,
	updateItemFinish,

	deleteItemsStart,
	deleteItemsSuccess,
	deleteItemsFailure,
	deleteItemsFinish,

	deleteItemStart,
	deleteItemSuccess,
	deleteItemFailure,
	deleteItemFinish,

	getTableStructureStart,
	getTableStructureSuccess,
	getTableStructureFailure,

	getItemDocumentsStart,
	getItemDocumentsSuccess,
	getItemDocumentsFailure,
	getItemDocumentsFinish,

	uploadItemDocumentsStart,
	uploadItemDocumentsSuccess,
	uploadItemDocumentsFailure,
	uploadItemDocumentsFinish,

	deleteItemDocumentStart,
	deleteItemDocumentSuccess,
	deleteItemDocumentFailure,
	deleteItemDocumentFinish,

	getTableExcelStart,
	getTableExcelSuccess,
	getTableExcelFailure,
	getTableExcelFinish,
} = taskSchedulerSlice.actions;
export default taskSchedulerSlice;
